import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as RemoveIcon } from 'icons/remove.svg';
import defaultHitImg from 'images/default_hit.jpg';
import { timelineStepRow } from 'themes/colors';
import ConfirmationModal from 'components/modals/ConfirmationModal';

function SelectedCoverage({
  data, logo, removeCoverage, readOnly,
}) {
  const selectedTile = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0.625rem 0rem',
    with: '100%',
    background: timelineStepRow,
  };
  const imgText = {
    marginRight: '1.25rem',
  };
  const label = {
    maxWidth: '25rem',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  };
  const [areYouSureOpen, setAreYouSureOpen] = useState(false);
  const [editCoverage, setEditCoverage] = useState(null);

  const toggleAreYouSure = (answer) => {
    if (answer) {
      setAreYouSureOpen(false);
      removeCoverage(editCoverage.value);
    } else {
      setAreYouSureOpen(answer);
    }
  };
  const toggle = (cover) => {
    setEditCoverage(cover);
    setAreYouSureOpen(prevState => !prevState);
  };

  return (
    <div style={selectedTile}>
      <div style={label}>
        <img
          src={logo || defaultHitImg}
          alt="logo"
          width={20}
          height={20}
          style={imgText}
        />
        <u>{data.label}</u>
      </div>
      {!readOnly &&
        <div>
          <IconButton onClick={() => toggle(data)}>
            <RemoveIcon />
          </IconButton>
        </div>
      }

      <ConfirmationModal
        open={areYouSureOpen}
        onBackdropClick={() => toggleAreYouSure(false)}
        title="Confirm"
        confirmLabel="Yes, unlink"
        cancelLabel="Cancel"
        onConfirmClick={() => toggleAreYouSure(true)}
        onCancelClick={() => toggleAreYouSure(false)}
        styles={{ zIndex: 1310 }}
      >
        Are you sure you want to unlink the coverage “{data.label}” with this opportunity?
      </ConfirmationModal>
    </div>
  );
}
SelectedCoverage.propTypes = {
  data: PropTypes.element.isRequired,
  logo: PropTypes.string.isRequired,
  removeCoverage: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
SelectedCoverage.defaultProps = {
  readOnly: false,
};
export default SelectedCoverage;
